// Modules
import { produce } from 'immer'

// Constants
import { localStorageFavouritesKey } from 'constants/index'

// Types
import {
  ADD_FAVOURITE_CURRENCY,
  SET_FAVOURITE_CURRENCY_LIST,
} from 'store/actions/FavouritesCurrency/types'

const initialState = {
  favouritesCurrencyList: JSON.parse(localStorage.getItem(localStorageFavouritesKey)) || [],
}

const favouritesCurrencyListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FAVOURITE_CURRENCY_LIST:
      return produce(state, (draft) => {
        draft.favouritesCurrencyList = action.payload
      })
    case ADD_FAVOURITE_CURRENCY:
      return produce(state, (draft) => {
        const itemIdToAdd = action.payload
        const itemIndexToAdd = draft.favouritesCurrencyList.findIndex(
          (item) => item?.id === itemIdToAdd?.id && item?.name === itemIdToAdd?.name,
        )

        if (itemIndexToAdd === -1) {
          draft.favouritesCurrencyList.push(action.payload)
        } else {
          draft.favouritesCurrencyList.splice(itemIndexToAdd, 1)
        }

        localStorage.setItem(
          localStorageFavouritesKey,
          JSON.stringify(draft.favouritesCurrencyList),
        )
      })
    default:
      return state
  }
}
export default favouritesCurrencyListReducer
